// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__fPAGv","hideOnTablet":"styles_hideOnTablet__3baUE","hideOnMobile":"styles_hideOnMobile__2wyZL"};